const isOutbound = (target) => {
  try {
    const currentDomain = window.location.hostname
    let linkHref = target.href

    if (!/^https?:\/\//.test(linkHref)) {
      linkHref = new URL(linkHref, window.location.href).href
    }

    const linkDomain = new URL(linkHref).hostname
    return linkDomain !== currentDomain
  } catch (error) {
    window.console.error('Error:', error)
    return false
  }
}

export default isOutbound
